var _g, _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntelligentScheduling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    enableBackground: "new 0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "S2hMnm.tif"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#006EC5",
    d: "M34.475,47.148c-0.896-0.176-1.808-0.287-2.68-0.535 c-5.313-1.518-9.006-6.723-8.703-12.217c0.315-5.738,4.483-10.48,10.032-11.42c6.832-1.157,13.086,3.338,14.18,10.191 c1.077,6.758-4.03,13.311-10.824,13.891c-0.151,0.012-0.3,0.059-0.451,0.09C35.512,47.148,34.992,47.148,34.475,47.148z  M36.023,34.58c0-0.252,0-0.441,0-0.629c0-2.002,0.017-4.008-0.019-6.01C36,27.645,35.829,27.242,35.6,27.076 c-0.524-0.369-1.105,0.098-1.108,0.848c-0.004,2.385-0.003,4.77-0.002,7.15c0.002,0.77,0.25,1.01,1.034,1.012 c1.763,0.002,3.524,0,5.287,0c0.673,0,1.347,0.012,2.021-0.008c0.512-0.012,0.792-0.307,0.778-0.77 c-0.01-0.438-0.288-0.705-0.774-0.723c-0.327-0.014-0.655-0.004-0.983-0.004C39.938,34.58,38.021,34.58,36.023,34.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#006EC5",
    d: "M31.17,0.851c0.276,0.081,0.556,0.145,0.825,0.246 c1.132,0.426,1.887,1.491,1.907,2.722c0.017,1.068,0.016,2.139,0.001,3.207c-0.022,1.667-1.282,2.953-2.901,2.982 c-1.661,0.031-3.007-1.204-3.068-2.875c-0.045-1.122-0.043-2.248,0-3.371c0.054-1.442,1.063-2.547,2.492-2.818 c0.105-0.02,0.206-0.062,0.31-0.093C30.881,0.851,31.026,0.851,31.17,0.851z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#006EC5",
    d: "M12.89,0.851c0.276,0.078,0.562,0.129,0.827,0.237 c1.093,0.446,1.824,1.24,1.899,2.429c0.083,1.297,0.092,2.61-0.003,3.906c-0.114,1.536-1.467,2.62-3.038,2.583 c-1.51-0.035-2.779-1.211-2.856-2.732C9.66,6.117,9.668,4.955,9.705,3.797c0.048-1.495,1.019-2.567,2.5-2.854 c0.085-0.017,0.167-0.061,0.249-0.092C12.6,0.851,12.745,0.851,12.89,0.851z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#006EC5",
    d: "M5.161,16.135c0,8.595,0,17.164,0,25.816c0.229,0,0.439,0,0.65,0 c5.33,0,10.661,0.008,15.992-0.008c0.517-0.002,0.836,0.109,1.126,0.594c0.911,1.521,2.134,2.781,3.626,3.904 c-0.193,0.031-0.302,0.066-0.41,0.066c-7.433,0.002-14.867,0-22.301,0.006c-0.659,0-1.211-0.221-1.648-0.697 c-1.046-1.139-1.616-2.482-1.62-4.037c-0.007-3.734-0.003-7.471-0.003-11.205c0-7.235,0.035-14.469-0.021-21.703 C0.536,6.876,1.891,5.356,4.006,5.439c1.356,0.053,2.715,0.01,4.173,0.01c0,0.575-0.018,1.112,0.003,1.647 c0.089,2.229,1.578,3.952,3.761,4.369c2.581,0.494,5.152-1.486,5.309-4.104c0.037-0.61,0.005-1.224,0.005-1.874 c3.08,0,6.078,0,9.102,0c0.037,0.735,0.02,1.461,0.12,2.17c0.34,2.407,2.429,4.026,4.916,3.856c2.261-0.155,4.1-2.153,4.129-4.489 c0.006-0.503,0.001-1.006,0.001-1.576c0.754,0,1.455,0,2.156,0c0.799,0,1.597-0.017,2.395,0.004 c1.739,0.047,3.048,1.327,3.054,3.038c0.015,4.641,0.005,9.283,0.004,13.925c0,0.054-0.01,0.107-0.013,0.124 c-1.469-0.643-2.945-1.289-4.523-1.98c0-1.356,0-2.87,0-4.425C27.438,16.135,16.333,16.135,5.161,16.135z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#006EC5",
    d: "M15.799,23.669c0-1.5,0-2.995,0-4.511c1.498,0,2.961,0,4.472,0 c0,1.499,0,2.988,0,4.511C18.792,23.669,17.314,23.669,15.799,23.669z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#006EC5",
    d: "M8.188,23.67c0-1.514,0-2.98,0-4.491c1.493,0,2.969,0,4.493,0 c0,1.477,0,2.968,0,4.491C11.198,23.67,9.722,23.67,8.188,23.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#006EC5",
    d: "M8.217,26.773c1.492,0,2.969,0,4.473,0c0,1.512,0,3.006,0,4.514 c-1.501,0-2.964,0-4.473,0C8.217,29.779,8.217,28.291,8.217,26.773z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#006EC5",
    d: "M15.801,31.273c0-1.502,0-2.994,0-4.496c1.51,0,2.988,0,4.491,0 c0,1.508,0,2.984,0,4.496C18.792,31.273,17.316,31.273,15.801,31.273z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#006EC5",
    d: "M8.202,38.879c0-1.508,0-2.984,0-4.494c1.496,0,2.972,0,4.486,0 c0,1.494,0,2.986,0,4.494C11.181,38.879,9.706,38.879,8.202,38.879z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#006EC5",
    d: "M15.8,34.371c1.506,0,2.968,0,4.474,0c0,1.5,0,2.988,0,4.51 c-1.49,0-2.963,0-4.474,0C15.8,37.381,15.8,35.906,15.8,34.371z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#006EC5",
    d: "M23.39,23.7c0-1.529,0-3.005,0-4.522c1.5,0,2.987,0,4.53,0 c0,0.951,0.009,1.889-0.013,2.824c-0.002,0.124-0.14,0.277-0.254,0.362c-0.54,0.396-1.09,0.775-1.642,1.154 c-0.115,0.078-0.25,0.171-0.378,0.174C24.896,23.708,24.158,23.7,23.39,23.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#006EC5",
    d: "M35.511,19.182c0,0.368,0,0.707,0,1.002 c-1.517,0.197-3.011,0.39-4.522,0.586c0-0.469,0-1.006,0-1.588C32.476,19.182,33.965,19.182,35.511,19.182z"
  })))), _image || (_image = /*#__PURE__*/React.createElement("image", {
    overflow: "visible",
    width: 933,
    height: 112,
    xlinkHref: "../../../../Desktop/Screen Shot 2020-03-26 at 11.09.50 AM.png",
    transform: "matrix(1 0 0 1 -499.75 -167.75)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntelligentScheduling);
export default __webpack_public_path__ + "static/media/Intelligent_scheduling.22bd07bb9e8ab38dedfbbe3a624797c6.svg";
export { ForwardRef as ReactComponent };